import { createPinia } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";

export const pinia = createPinia().use(createPersistedState());

export * from "./player.store";
export * from "./session.store";
